import KunLoading44 from './src/index'

KunLoading44.install = function (Vue) {
	Vue.component(KunLoading44.name, KunLoading44);
}

export default KunLoading44;
